var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFlagItalian = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2043_979",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
  fill: "#C4C4C4"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2043_979)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 0L24 24L16 24L16 -3.49691e-07L24 0Z",
  fill: "#FF3333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 0L16 24L8 24L8 -3.49691e-07L16 0Z",
  fill: "#F3F4F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 0L8 24L-1.04907e-06 24L0 -3.49691e-07L8 0Z",
  fill: "#019364"
}))));
export default SvgFlagItalian;